import React, {useEffect, useState} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Select, {Option} from "rc-select";
import Alert from "react-s-alert";

const InvoiceLineItsUtsModal = (props) => {
    const {modal, listener, index, trdDocInvoiceLines} = props;
    const [trdDocInvoiceLine, setTrdsDocInvoiceLine] = useState(trdDocInvoiceLines[index]);
    const [dataList, setDataList] = useState(trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes);
    const [imeiList, setImeiList] = useState([{imei: null, productIndex: null}]);
    const [imeiRow, setImeiRow] = useState(false);

    useEffect(() => {
        if (props.invoiceTypeCode === 'TEKNOLOJIDESTEK' && dataList.length > 0) {
            for (let i = 0; i < dataList.length; i++) {
                if (dataList[i].productModelType === 'TELEFON') {
                    setImeiRow(true);
                    const addList = dataList[i].productModelCode?.split(';').map(m => ({
                        imei: m,
                        productIndex: i
                    }));
                    setImeiList(addList);
                }
            }
        } else {
            setImeiList([{imei: null, productIndex: null}]);
        }
    }, []);

    const handleChange = (selectedValue, indexIts, type) => {
        const updatedDataList = [...dataList];
        updatedDataList[indexIts][type] = selectedValue;
        if (type === 'productModelType' && selectedValue === 'TABLET_PC') {
            updatedDataList[indexIts]['productModelCode'] = null;
            if (imeiRow) {
                setImeiRow(false);
            }
        } else if (type === 'productModelType' && selectedValue === 'TELEFON') {
            setImeiRow(true);
        }
        setDataList(updatedDataList);
    };

    const handleChangeImei = (selectedValue, index, indexIts) => {
        const updatedImeiList = [...imeiList];
        if (updatedImeiList.length > 0) {
            updatedImeiList[index]['imei'] = selectedValue;
            updatedImeiList[index]['productIndex'] = indexIts;
        } else {
            updatedImeiList.push({imei: selectedValue, productIndex: indexIts});
        }
        setImeiList(updatedImeiList);
    }

    const addImeiLine = () => {
        const updatedImeiList = [...imeiList];
        updatedImeiList.push({imei: null, productIndex: null});
        setImeiList(updatedImeiList);
    }

    const deleteImeiLine = () => {
        const updatedImeiList = [...imeiList];
        updatedImeiList.pop();
        setImeiList(updatedImeiList);
    }

    const isOpen = () => {
        props.closeModal();
    };

    const setInvoiceLineItsUts = () => {
        if (props.profileId === 'ILAC_TIBBICIHAZ') {
            if (dataList.length > 0) {
                let kontrol = true;
                dataList.map(data => {
                    if (data.productModelType === null || data.productModelCode === null || data.productModelType === "" || data.productModelCode === "") {
                        kontrol = false;
                    }
                })
                if (!kontrol) {
                    return Alert.error("Ürün tipi ve karekodunu doldurunuz.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000,
                        html: false
                    });
                } else {
                    let invoiceLine = {...trdDocInvoiceLine, trdDocInvoiceLineProductModelCodes: dataList};
                    listener(invoiceLine, index);
                    props.closeModal();
                }
            } else {
                return Alert.error("Ürün tipi ve karekodunu doldurunuz.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            }
        } else if (props.invoiceTypeCode === 'TEKNOLOJIDESTEK') {
            if (dataList.length > 0) {
                let kontrol = true;
                dataList.map((data, index) => {
                    if (data.productModelType === null) {
                        kontrol = false;
                    }

                    if (data.productModelType === 'TELEFON') {
                        if (imeiList.length === 0 || (imeiList.length > 0 && imeiList[index].imei === null)) {
                            kontrol = false
                        } else {
                            const list = imeiList
                                .filter(f => f.productIndex === index && f.imei)
                                .map((f, i) => {
                                    const regex = /(IMEI)/g;
                                    if (regex.test(f.imei)) {
                                        return f.imei;
                                    } else {
                                        return `(IMEI${i + 1})${f.imei}`
                                    }
                                });

                            if (list.length > 0) {
                                data.productModelCode = list.toString().replaceAll(",", ";").replace("IMEI1", "IMEI");
                            } else {
                                kontrol = false;
                            }
                        }
                    }

                    if (!kontrol) {
                        return Alert.error("Ürün tipi ve IMEI Bilgisi doldurunuz.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 5000,
                            html: false
                        });
                    } else {
                        let invoiceLine = {...trdDocInvoiceLine, trdDocInvoiceLineProductModelCodes: dataList};
                        listener(invoiceLine, index);
                        props.closeModal();
                    }
                })
            }
        } else {
            return Alert.error("Ürün tipini doldurunuz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }

    };

    return (
            <Modal isOpen={modal} toggle={isOpen} size="lg" backdrop={false}>
                <style>
                    {`
      .rc-select-dropdown {
        z-index: 1060 !important;
      }
    `}
                </style>
                <ModalHeader>{props.invoiceTypeCode === 'TEKNOLOJIDESTEK' ? 'Teknolojik Destek Kalemleri' : 'İts/Üts Bilgileri'}</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="form-group">
                            <table className="" style={{textAlign: "center"}}>
                                <thead>
                                {props.profileId === 'ILAC_TIBBICIHAZ' &&
                                    <tr>
                                        <th width="5%">Satır Numarası</th>
                                        <th width="40%">Ürün Tipi</th>
                                        <th width="55%">Ürün KareKodu</th>
                                    </tr>
                                }
                                {props.invoiceTypeCode === 'TEKNOLOJIDESTEK' &&
                                    <tr>
                                        <th width="5%">Satır Numarası</th>
                                        <th width="40%">Ürün Tipi</th>
                                        {imeiRow &&
                                        <th width="55%">IMEI Bilgisi</th>
                                        }
                                        {<th></th>}
                                    </tr>
                                }
                                </thead>
                                <tbody>
                                {dataList?.map((trdDocItsUtsLine, indexIts) => (
                                    <tr key={indexIts}>
                                        <td>{indexIts + 1}</td>
                                        <td>
                                            <Select
                                                style={{width: "100%"}}
                                                dropdownMenuStyle={{maxHeight: 200}}
                                                getPopupContainer={() => document.body}
                                                id={"productType_" + indexIts}
                                                className="select-control"
                                                value={trdDocItsUtsLine.productModelType}
                                                onChange={(value) => handleChange(value, indexIts, "productModelType")}
                                                placeholder="Seçiniz..."
                                            >
                                                {props.profileId === 'ILAC_TIBBICIHAZ' &&
                                                    <Option value="TIBBICIHAZ">Tıbbi Cihaz</Option>
                                                }
                                                {props.profileId === 'ILAC_TIBBICIHAZ' &&
                                                    <Option value="ILAC">İlaç</Option>
                                                }
                                                {props.invoiceTypeCode === 'TEKNOLOJIDESTEK' &&
                                                    <Option value="TELEFON">Telefon</Option>
                                                }
                                                {props.invoiceTypeCode === 'TEKNOLOJIDESTEK' &&
                                                    <Option value="TABLET_PC">Tablet - Bilgisayar</Option>
                                                }
                                            </Select>
                                        </td>
                                        <td>
                                            {props.profileId === 'ILAC_TIBBICIHAZ' &&
                                                <input
                                                    id={"karekod_" + indexIts}
                                                    className="form-control"
                                                    onChange={(e) => handleChange(e.target.value, indexIts, "productModelCode")}
                                                    value={trdDocItsUtsLine.productModelCode}
                                                />
                                            }
                                            {(trdDocItsUtsLine.productModelType !== undefined && trdDocItsUtsLine.productModelType === 'TELEFON' && props.invoiceTypeCode === 'TEKNOLOJIDESTEK') &&
                                                imeiList?.map((imei, indexImei) => (
                                                    <input
                                                        id={"imei_" + indexIts}
                                                        className="form-control"
                                                        onChange={(e) => handleChangeImei(e.target.value, indexImei, indexIts)}
                                                        value={imei.imei || ''}
                                                    />
                                                ))
                                            }
                                        </td>
                                        {(trdDocItsUtsLine.productModelType !== undefined && trdDocItsUtsLine.productModelType === 'TELEFON' && props.invoiceTypeCode === 'TEKNOLOJIDESTEK') &&
                                            <td>
                                                <button type="button" className="Btn ekle"
                                                        style={{margin: "0", background: '#FFCCCC'}}
                                                        onClick={() => addImeiLine()}/>
                                                <button type="button" className="Btn temizle"
                                                        style={{margin: "0", background: '#FFCCCC'}}
                                                        disabled={imeiList.length < 2}
                                                        onClick={() => deleteImeiLine()}/>
                                            </td>
                                        }
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="TekBtn kaydet"
                        style={{padding: "10px 42px 10px 10px", marginLeft: "4px"}}
                        onClick={setInvoiceLineItsUts}
                    >
                        Kaydet
                    </button>
                </ModalFooter>
            </Modal>
    );
};

export default InvoiceLineItsUtsModal;
